import React from "react"

var width=0;
const formImageSrcSet = params => {
  const keys = Object.keys(params.transforms),
    keysLength = keys.length
  let imageSrcSet = {
    src: params.images[keys[keysLength - 1]],
    srcSet: "",
    sizes: ""
  }
  for (let index = 0; index < keysLength; index++) {
    width = keys[index].substr(0, keys[index].search(/[a-z]/i))
    imageSrcSet.srcSet += `${params.images[keys[index]]} ${width}w, `
    imageSrcSet.sizes += `${params.transforms[keys[index]]} ${width}px, `
   
  }
  return imageSrcSet
}

const SrcSetImage = ({ props }) => {
  if (props.images) {
    const ImageSrcSet = formImageSrcSet(props)
    return <img alt={"image place"} sptext={props?.loadLazy} loading={props?.loadLazy === false ? "" : "lazy" }
                {...ImageSrcSet}
                {...props.attr}
                width= {width}
                height="auto"
    />
  }
  return ""
}

export default SrcSetImage
